(function ErezHotelEngineBookingForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'HotelEngineBooking',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.confirmation = function confirmation(response)
	{
		Adzuki.Erez.ClientDuplicateEmail.confirm(response, form.name);
	};

	form.load = function load($form)
	{
		var require_titles = requireTitles();

		hideRequired();

		// if an existing client is selected for adult 1, try to fill in some billing and payment information details
		$(".existing-client.adzuki-typeahead").first().on('ta.set-hidden', function getClientCCs(e, client_id) {

			Adzuki.Ajax.get('/Clients/getClientDetails/' + client_id)
			.then(function fillClientDetails(client_details) {
				console.log(client_details);
				$('#hotelenginebooking-customer-first_name').val(client_details.first_name);
				$('#hotelenginebooking-customer-last_name').val(client_details.last_name);
				$('#hotelenginebooking-customer-email').val(client_details.email);
				$('#hotelenginebooking-customer-phone').val(client_details.mobile_phone);

				if (require_titles === true) {
					// remove period
					$('#hotelenginebooking-additional_info-0-guest_title').val(formatTitle(client_details.prefix));
				}
			});

			Adzuki.Ajax.get('/ClientAddresses/getAddressesByClientId/' + client_id + '/1')
			.then(function fillClientAddressDetails(addresses) {
				var post_addresses = new Map();
				post_addresses.set('', 'Enter New Address');

				$.each(addresses, function onEachAddress(i) {
					if (addresses[i].address1.length > 0) {
						post_addresses.set(addresses[i].id, addresses[i].single_line_address);
					}
				});

				toggleDynamicDD($('#client-address-select'), post_addresses);
			});

			Adzuki.Ajax.get('/ClientCreditCards/getCardDetailsByClientId/' + client_id + '/1/1')
			.then(function fillCcDetails(ccs) {
				var post_ccs = new Map();
				post_ccs.set('', 'Enter New Credit Card');

				$.each(ccs, function onEachCC(i) {
					post_ccs.set(ccs[i].id, ccs[i].label);
				});

				toggleDynamicDD($('#client-cc-select'), post_ccs, false);
			});

		})
		.on('ta.reset', function resetCCField() {
			var empty_options = new Map();

			$('#hotelenginebooking-customer-first_name').val('');
			$('#hotelenginebooking-customer-last_name').val('');
			$('#hotelenginebooking-customer-email').val('');
			$('#hotelenginebooking-customer-phone').val('');
			$('#hotelenginebooking-customer-address1').val('');
			$('#hotelenginebooking-customer-address2').val('');
			$('#hotelenginebooking-customer-city').val('');
			$('#hotelenginebooking-customer-state_iso').val('');
			$('#hotelenginebooking-customer-zip').val('');

			// toggleClientAddress(null);
			// toggleClientCreditCards(null);
			toggleDynamicDD($('#client-address-select'), empty_options);
			toggleDynamicDD($('#client-cc-select'), empty_options);

			$('#hotelenginebooking-payment-name_on_card').val('');
			$('#hotelenginebooking-payment-number').val('');
			$("#hotelenginebooking-payment-expiration_date").val('');
			$('#hotelenginebooking-payment-type').val('');
			$('#hotelenginebooking-payment-cvv').val('');

			if (require_titles === true) {
				$('#hotelenginebooking-additional_info-0-guest_title').val('');
			}
		});

		// if titles are required, any time an existing client is selected from typeahead, see if we can auto populate the subsequent Guest Title inputs
		if (require_titles) {
			$(".existing-client.adzuki-typeahead:not(:first)").on('ta.set-hidden', function getClient(e, client_id) {
				var index = getClientIndex($(this));

				Adzuki.Ajax.get('/Clients/getClientDetails/' + client_id)
				.then(function fillClientDetails(client_details) {
					// remove period
					var title = formatTitle(client_details.prefix);
					$('#hotelenginebooking-additional_info-' + index + '-guest_title').val(title);
				});
			}).on('ta.reset', function resetTitle() {
				var index = getClientIndex($(this));
				$('#hotelenginebooking-additional_info-' + index + '-guest_title').val('');
			});

			// for new clients, if Prefix selected, set Guest Title under "Additional Information"
			$('.prefix-type').on('change', function changePrefix() {
				var index = getClientIndex($(this)),
				    title = formatTitle($(this).val());

				$('#hotelenginebooking-additional_info-' + index + '-guest_title').val(title);
			});
		}

		// typeahead for merging into existing rez
		if ($('#hotelenginebooking-merge_into_reservation').val() !== undefined) {
			Adzuki.Typeahead(
				'#hotelenginebooking-merge_into_reservation',
				'/Reservations/autocompleteUpcoming/',
				function selected(item, $self, typeahead) {
					typeahead.setHiddenValue(item.id);
				}
			);
		}

		// enable submit button when T&C checkbox checked
		$('#agree').click(function _enableSubmit() {
			if ($(this).prop('checked') === true) {
				$('.submit-booking').removeClass('disabled');
				$('.submit-booking').prop('disabled', null);
			} else {
				$('.submit-booking').addClass('disabled');
				$('.submit-booking').prop('disabled', true);
			}
		});

		$('#hotelenginebooking-customer-client_address_id').on('change', function onAddressChange(event) {
			var address_id = $(this).val();

			if (address_id === '') {
				$('#hotelenginebooking-customer-address1').val('');
				$('#hotelenginebooking-customer-address2').val('');
				$('#hotelenginebooking-customer-city').val('');
				$('#hotelenginebooking-customer-state_iso').val('');
				$('#hotelenginebooking-customer-zip').val('');
				$('#hotelenginebooking-customer-country_id').val('');

			} else {
				Adzuki.Ajax.get('/ClientAddresses/_ajaxGetAddress/' + address_id)
				.then(function success(client_address) {
					var selected_state_id = null;

					$('#hotelenginebooking-customer-address1').val(client_address.address1);
					$('#hotelenginebooking-customer-address2').val(client_address.address2);
					$('#hotelenginebooking-customer-city').val(client_address.city);
					$('#hotelenginebooking-customer-zip').val(client_address.zip);

					if (client_address.state_id) {
						selected_state_id = client_address.state_id;
					}

					// set country
					$('#hotelenginebooking-customer-country_id').val(client_address.country_id);

					// build state dd options based on country and then set the selected state
					countryChange(client_address.country_id, $('#hotelenginebooking-customer-state_id'), selected_state_id);
				});
			}
		});

		$('#hotelenginebooking-customer-country_id').on('change', function changeCountry() {
			countryChange(
				$(this).val(),
				$('#hotelenginebooking-customer-state_id')
			);
		});

		$('#hotelenginebooking-payment-credit_card_id').on('change', function fetchCCData() {
			if (this.value) {
				Adzuki.Ajax.get('/ClientCreditCards/get/' + this.value + '/1/1')
				.then((cc_info) => fillBillingInfo(cc_info));
			} else {
				fillBillingInfo({});
			}
		});

		// specific to Web app. copy text to other fields by default
		$('.web-copy').on('change', function copyText(event) {
			var $self = $(this),
			    val   = $self.val(),
			    id,
			    combined;

			if ($self.hasClass('email')) {
				id = 'hotelenginebooking-customer-email';
			}

			if ($self.hasClass('first-name')) {
				id = 'hotelenginebooking-customer-first_name';
			}

			if ($self.hasClass('last-name')) {
				id = 'hotelenginebooking-customer-last_name';
			}

			$('#' + id).val(val);

			combined = $('#hotelenginebooking-customer-first_name').val() + ' ' + $('#hotelenginebooking-customer-last_name').val();
			$('#hotelenginebooking-payment-name_on_card').val(combined);
		});

		function fillBillingInfo(cc_info)
		{
			var $cc_number    = $('#hotelenginebooking-payment-number'),
			    num_token     = (cc_info.number_token ? cc_info.number_token : null),
			    $ccv_number   = $('#hotelenginebooking-payment-cvv'),
			    ccv_token     = (cc_info.ccv_token ? cc_info.ccv_token : ''),
			    secure_tokens = [];

			if (num_token === null) {
				$cc_number.removeAttr('data-token');
				$ccv_number.removeAttr('data-ccv_token');

				$('.cc-num-ss-link').addClass('hidden');
				$('.cc-num-span').removeClass('input-group');

				$cc_number.val('').focus();
				$ccv_number.val('');
			} else {
				$('.cc-num-span').addClass('input-group');
				$('.cc-num-ss-link').removeClass('hidden');

				$cc_number.attr('data-token', num_token);
				$ccv_number.attr('data-ccv_token', ccv_token);

				secure_tokens[0] = num_token;

				if (ccv_token !== '') {
					secure_tokens[1] = ccv_token;
				}

				Adzuki.SecureStorage.detokenize({
					secure_storage_tokens: secure_tokens,
					success              : function success(plain_texts) {
						$cc_number.val(plain_texts[0]);

						if (plain_texts.length === 2) {
							$ccv_number.val(plain_texts[1]);
						}
					}
				});
			}

			$("#hotelenginebooking-payment-name_on_card").val(cc_info.name);
			$("#hotelenginebooking-payment-type").val(cc_info.credit_card_sabre_code).trigger('change');

			if (Adzuki.is_mobile) {
				$("#hotelenginebooking-payment-expiration_date").val(cc_info.expiration);
			} else {
				$("#hotelenginebooking-payment-expiration_date").data('DateTimePicker').date(moment(cc_info.expiration));
			}
		}

		function formatTitle(str)
		{
			if ( (str) && (str.length > 0) ) {
				return str.replace(/.$/, '');
			}
		}

		function getClientIndex($el)
		{
			var $traveler = $el.closest('.traveler');
			return $traveler.data('client-index');
		}

		// only the first client is required, so hide required indication on label for subsequent clients
		function hideRequired() {
			var $rooms  = $('.room-clients');

			// this means that we are going to require all of the clients
			if (require_titles) {
				return false;
			}

			// show required for the first adult in each room
			$rooms.each(function hideRequired(index) {
				var $labels = $(this).find('.existing-client-fields .required');

				$labels.each(function hideRequired(index) {
					if (index > 0) {
						$(this).addClass('hidden');
					}
				});
			});
		}

		function requireTitles()
		{
			if ($('#include_titles').length) {
				return true;
			}

			return false;
		}

		/**
		 * toggle populate selects. needs a class of .dynamic-dd on the <select>
		 *
		 * @param  jQueryObj $element  element containing the <select>
		 * @param  obj       options  essentially a key => value array to populate <select> options. Null if emptying
		 */
		function toggleDynamicDD($element, options, auto_select = true)
		{
			var $select = $element.find('.dynamic-dd'),
			    markup;

			$select.empty();

			if (options.size < 1) {
				$element.addClass('hidden');
				$select.prop('disabled', true);
			} else {
				$element.removeClass('hidden');
				$select.prop('disabled', false);

				// add empty option
				// $select.append('<option value=""></option>');

				for (let [key, value] of options) {
					markup = '';
					markup += '<option value="' + key + '">';
					markup += value;
					markup += '</option>';

					if (value !== '') {
						$select.append(markup);
					}
				}

				// select the first real option in the list
				if (auto_select === true) {
					$select.find('option:eq(1)').attr('selected', 'selected').trigger('change');
				}
			}
		}

		function countryChange(country_id, $state_el, selected_state_id)
		{
			$state_el.empty();

			Adzuki.Ajax.get('/States/getByCountryId/' + country_id).then(function success(response) {
				Adzuki.Address.populateState($state_el, response);
				if (selected_state_id !== 'undefined') {
					$state_el.val(selected_state_id);
				}
			});

			adjustLabels(country_id);
		}

		// if country is Canada, need to show different labels for State and Zip fields
		function adjustLabels(country_id)
		{
			var $state_label = $('#state-label'),
			    $zip_label   = $('#zip-label'),
			    state_txt    = 'State',
			    zip_txt      = 'Zip';

			// canada
			if (country_id === '31') {
				state_txt = $state_label.data('state-label-ca');
				zip_txt   = $zip_label.data('zip-label-ca');
			}

			replaceOnlyLabelTxt($state_label, state_txt);
			replaceOnlyLabelTxt($zip_label, zip_txt);
		}

		// don't replace elements within an element. Only replace its text. For example, labels contain <span class="required"></span>. don't want to replace those
		function replaceOnlyLabelTxt($el, text)
		{
			$el.contents().filter(
				function fil() {
					return this.nodeType === 3;
				}
			).first().replaceWith(" " + text);
		}
	};
}(jQuery, window.Adzuki || {}));
